import { IconMail } from './IconMail'

export default IconMail
